export default __webpack_public_path__ + "static/media/iform_menej.b1cf1efc.jpeg";